<template>
  <v-card>
    <v-card-title>
      <span>{{ $t('reports_ui.fleet_health_report.vehicle_issues_trend') }}</span>
      <info-modal>
        <v-card-title>
          {{ $t('reports_ui.fleet_health_report.temperature_violations_trend') }}
        </v-card-title>
        <v-card-text v-html="$t('reports_ui.fleet_health_report.modal_info.temperature_violations_trend')" />
      </info-modal>
    </v-card-title>
    <v-card-text>
      <c3-chart :height="365" :data="chartData" :config="chartConfig" type='line' />
      <div class="text-center text-muted">
        {{ $t('reports_ui.fleet_health_report.temperature_violations_over_time')}}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import C3Chart from '@/components/shared/chart/C3Chart.vue'
import InfoModal from '@/components/shared/InfoModal'
import { map, keys, get } from 'lodash'

export default {
  name: 'TemperatureViolationTrends',
  components: {
    C3Chart,
    InfoModal
  },
  props: {
    customerReport: {
      type: Object
    }
  },
  computed: {
    /**
     * Format the chart data needed for the graph.
     * @returns Object
     */
    chartData () {
      const dateColumn = keys(this.customerReport.insights_dashboard_history)
      dateColumn.unshift('date')

      const hotViolationsColumn = this.getMappedData('hot_violations')
      hotViolationsColumn.unshift(this.$t('hot_violations'))

      const coldViolationsColumn = this.getMappedData('cold_violations')
      coldViolationsColumn.unshift(this.$t('cold_violations'))

      return {
        x: 'date',
        columns: [
          dateColumn,
          hotViolationsColumn,
          coldViolationsColumn
        ]
      }
    },
    /**
     * The chart config.
     */
    chartConfig () {
      return {
        axis: {
          x: {
            label: {
              text: this.$t('date')
            },
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d',
              centered: true
            }
          },
          y: {
            label: {
              text: this.$t('reports_ui.fleet_health_report.number_of_violations')
            },
            tick: {
              format: function (d) {
                return parseInt(d) === d ? d : null
              },
              culling: true
            }
          }
        },
        line: {
          connectNull: true
        }
      }
    }
  },
  methods: {
    /**
     * Convenience method to get data from the insights_dashboard_history field.
     * @param field
     * @returns {*}
     */
    getMappedData (field) {
      return map(this.customerReport.insights_dashboard_history, x => get(x, field, null))
    }
  }
}
</script>

<style scoped>

</style>
